export const mockAgentDefault = {
  ZPAR: {
    phone: true,
    email: false,
    whatsapp: true
  },
  '24MX': {
    phone: true,
    email: true,
    whatsapp: true
  },
  VAMX: {
    phone: true,
    email: true,
    whatsapp: true
  },
  CAPA: {
    phone: true,
    email: true,
    whatsapp: true
  },
  IWBR: {
    phone: true,
    email: true,
    whatsapp: false
  },
  ICBR: {
    phone: true,
    email: true,
    whatsapp: false
  },
  CMBR: {
    phone: true,
    email: true,
    whatsapp: false
  },
  DVPE: {
    phone: true,
    email: false,
    whatsapp: false
  },
  UBPE: {
    phone: true,
    email: false,
    whatsapp: false
  },
  PLEC: {
    phone: true,
    email: true,
    whatsapp: true
  }
};
